import { QueryClient } from "@tanstack/react-query";
import { SIGNED_URL_STALE_TIME } from "@/constants/file";
import { QUERY_KEYS } from "@/constants/queryKeys";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      staleTime: 5000, // After 5 seconds have elapsed since the data was retrieved
      gcTime: 5000, //  Data in cache is retained until 5 seconds has passed
      retry: 0,
    },
  },
});

// Keep signed URLs (incl. ones primed from list responses) cached for their stale window
// instead of the 5s default, so images further down a long list don't refetch one by one.
queryClient.setQueryDefaults([QUERY_KEYS.FILE.FETCH_SIGNED_URL], { gcTime: SIGNED_URL_STALE_TIME });

export const queryClientNoCache = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
    },
  },
});
